<script setup>
import Button from "@/common/Button.vue"

import {usePageEditorStore} from '@/stores/pageEditor'

const pageEditorStore = usePageEditorStore()

const deleteSection = () => {
    pageEditorStore.deleteSection()
}
</script>

<template>
    <Button @click="deleteSection" class="btn-sm d-flex align-items-center gap-2 text-danger">
        <i class="bi bi-trash"></i>
        Delete section
    </Button>
</template>